/**
 * CORE-708 — the milestone contract approved for the owner celebration.
 *
 * Keep this table deliberately finite. The backend sends the threshold in
 * `GamificationEvent.value`; matching by that stable number (rather than by
 * localized title/message copy) keeps the same Canonical v4 medallion on web
 * and native.
 */
export const MILESTONE_CATALOG = [
  { threshold: 3, name: 'Первый Огонёк', icon: 'flame' },
  { threshold: 7, name: 'Неделя Света', icon: 'soul-light' },
  { threshold: 21, name: 'Росток Привычки', icon: 'sprout' },
  { threshold: 40, name: 'Космический порядок', icon: 'calendar-plus' },
  { threshold: 108, name: 'Свет сознания', icon: 'progress' },
  { threshold: 365, name: 'Световой год', icon: 'shield-star' },
] as const;

export type MilestoneDefinition = (typeof MILESTONE_CATALOG)[number];
export type MilestoneIconKey = MilestoneDefinition['icon'];

export function getMilestoneDefinition(value: number | null | undefined): MilestoneDefinition | null {
  if (value == null) return null;
  return MILESTONE_CATALOG.find((milestone) => milestone.threshold === value) ?? null;
}

export function milestoneDayWord(value: number): 'день' | 'дня' | 'дней' {
  const mod100 = Math.abs(value) % 100;
  const mod10 = mod100 % 10;
  if (mod100 >= 11 && mod100 <= 14) return 'дней';
  if (mod10 === 1) return 'день';
  if (mod10 >= 2 && mod10 <= 4) return 'дня';
  return 'дней';
}

export function formatMilestoneDays(value: number): string {
  return `${value} ${milestoneDayWord(value)}`;
}
